import { render, staticRenderFns } from "./IndexV2.vue?vue&type=template&id=5368ba5c&scoped=true&"
import script from "./IndexV2.vue?vue&type=script&lang=js&"
export * from "./IndexV2.vue?vue&type=script&lang=js&"
import style0 from "./IndexV2.vue?vue&type=style&index=0&id=5368ba5c&prod&lang=scss&scoped=true&"
import style1 from "./IndexV2.vue?vue&type=style&index=1&id=5368ba5c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5368ba5c",
  null
  
)

export default component.exports